export function 
conditonal_values(inputMode) {
  let styles = {
    bg_input: "common.white",
    padding_input: "",
    action_button: "primary",
    action_button_text: undefined,
    action_button_loading: "common.white",
  };
  let content = {
    action_button: "ثبت کد",
  };

  if (inputMode === "error") {
    styles.bg_input = "red.light500";
    styles.padding_input = "l";
  }
  if (inputMode === "filled") {
    styles.bg_input = "green.light500";
    styles.padding_input = "l";
    styles.action_button = "white";
    styles.action_button_text = "red.main";
    styles.action_button_loading = "red.main";

    content.action_button = "حذف کد";
  }

  return {
    styles,
    content,
  };
}
